<template>
  <div class="suspiciousRulers">
    <div class="breadcrumb">
      规则设置
      <el-button
        type="primary"
        @click="dialogFormVisible = true"
        class="right_f"
        >权重设置</el-button
      >
      <el-button type="primary" @click="save" class="right_f">保存</el-button>
      <el-button type="primary" @click="cancel" class="right_f">返回</el-button>
    </div>

    <p>
      规则说明：
      <br />1.违规线分数设置后，当用户每日总分>=违规线分数时，将会进入可疑用户列表
      <br />
      2.权重设置分为两个维度即每日私信以及关注人数
    </p>

    <div>
      <el-form
        ref="rulesForm"
        :rules="rules"
        :model="rulesForm"
        label-width="130px"
      >
        <el-form-item label="违规分数线：" prop="score">
          <el-input v-model="rulesForm.score" placeholder=""></el-input>
        </el-form-item>
        <p>
          权重说明： 1个关注记{{ formedit.score1 }}分，1个私信记{{
            formedit.score2
          }}分
        </p>
      </el-form>
    </div>

    <el-dialog
      title="权重设置"
      v-model="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="formedit" :rules="rules" ref="formedit">
        <el-form-item
          label="1个关注分数："
          :label-width="formLabelWidth"
          prop="score1"
        >
          <el-input v-model="formedit.score1" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="1个私信分数："
          :label-width="formLabelWidth"
          prop="score2"
        >
          <el-input v-model="formedit.score2" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: function () {
    let checkInt = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(value * 1)) {
          callback(new Error("请输入整数"));
        } else {
          if (value * 1 <= 0) {
            callback(new Error("请输入正数"));
          } else {
            callback();
          }
        }
      } else {
        callback(new Error("请输入分数"));
      }
    };
    return {
      rulesForm: {
        score: "",
      },
      formedit: {
        score1: "",
        score2: "",
      },
      formLabelWidth: "130px",
      dialogFormVisible: true,
      rules: {
        score: [{ validator: checkInt }],
        score1: [{ validator: checkInt }],
        score2: [{ validator: checkInt }],
      },
    };
  },
  mounted() {
    this.dialogFormVisible = false;
    this.getRulesDetail();
  },
  methods: {
    //保存
    save() {
      this.$refs.rulesForm.validate((valid) => {
        if (valid) {
          this.$refs.formedit.validate((form_valid) => {
            if (form_valid) {
              this.$http({
                method: "POST",
                url: `${this.$util.domain}/adminapi/v4/user/suspicious/saverules`,
                body: JSON.stringify({
                  fanScore: this.formedit.score1 * 1,
                  privateMsgScore: this.formedit.score2 * 1,
                  scoreLine: this.rulesForm.score * 1,
                }),
              }).then(
                (response) => {
                  if (response.data.error === 10000) {
                    this.$util.successMsg("保存成功");
                    location.href = "/#/userM/suspicious";
                  } else {
                    this.$util.errorMsg(response.data.message);
                  }
                },
                (response) => {
                  this.$util.errorMsg(response.data.message);
                }
              );
            }
          });
        }
      });
    },
    //获取规则详情
    getRulesDetail() {
      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v4/user/suspicious/getrules",
      }).then((response) => {
        if (response.data.error === 10000) {
          let dataObj = response.data.data;
          this.rulesForm.score = dataObj.scoreLine + "";
          this.formedit.score1 = dataObj.fanScore + "";
          this.formedit.score2 = dataObj.privateMsgScore + "";
        }
      });
    },
    cancel() {
      history.back();
    },
  },
};
</script>
<style>
.suspiciousRulers {
  padding-bottom: 40px;
}

.suspiciousRulers .el-select {
  display: inline-block;
  width: 20%;
}

.suspiciousRulers .el-input {
  display: inline-block;
  width: 40%;
}

.suspiciousRulers .el-button {
  display: inline-block;
}

.suspiciousRulers .el-button + .el-button {
  margin-left: 0;
}

.search {
  margin-left: 30px;
}

.datas {
  margin-top: 20px;
}

.el-dialog__body p {
  line-height: 38px;
}

.suspiciousRulers .time {
  width: 15%;
}

.suspiciousRulers p {
  padding: 0 30px;
  line-height: 25px;
  font-size: 14px;
  color: red;
  margin-bottom: 20px;
}

.el-table .read-row {
  background: #eff2f7;
}
</style>



// WEBPACK FOOTER //
// suspiciousRulers.vue?1416d283